/* @flow */

import * as React from 'react';
import type {FieldArrayProps} from 'redux-form';

import type {ListOptionWithCount} from 'shells/select-option-components/option-with-count';

import {GraphQLSelectAudiencesProvider} from '../../select/graphql-select-audiences-provider';
import {CreateableField} from './createable-field';
import {useSetNewItem} from './use-set-new-item';

import './forms.css';

type Props = {
    ...FieldArrayProps,
    shouldAnd: boolean,
};

export function AudienceSelect(props: Props) {
    const [audienceOptions, setAudienceOptions] = React.useState<ListOptionWithCount[]>([]);
    const [newAudience, setNewAudience] = React.useState<?string>(null);

    const {fields} = props;

    if (fields.length === 0) {
        // If we don't have any audiences, add an empty value
        fields.push(null);
    }

    useSetNewItem(newAudience, setNewAudience, fields);

    return (
        <GraphQLSelectAudiencesProvider>
            {({options, isLoading, refetch}) => {
                // We start with '-- Manage audiences --' so we don't want to set the options
                // unless we have more than just that option
                if (options.length > 1 && !audienceOptions.length) {
                    setAudienceOptions(options);
                }

                return (
                    <CreateableField
                        {...props}
                        setNewItem={(newValue: ?string) => setNewAudience(newValue)}
                        setOptions={(newValue: ListOptionWithCount[]) =>
                            setAudienceOptions(newValue)
                        }
                        options={audienceOptions}
                        refetch={refetch}
                        shouldAnd={props.shouldAnd}
                        isLoading={isLoading}
                        type='audiences'
                    />
                );
            }}
        </GraphQLSelectAudiencesProvider>
    );
}
